import { getReviewFormData } from '../../submission/get-review-form-data';

export type IsStarRatingValidParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const isStarRatingValid = async ({ rootElement }: IsStarRatingValidParams) => {
    const reviewFormData = await getReviewFormData({ rootElement });
    return reviewFormData.stars !== undefined;
};
